import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const RouterTrackerForAnalytics = () => {
  const location = useLocation();
  const GA_ID = process.env.GOOGLE_ANALYTICS_ID;

  // 1. 초기화 (앱 실행 시 최초 1회)
  useEffect(() => {
    if (GA_ID) {
      ReactGA.initialize(GA_ID);
    }
  }, [GA_ID]);

  // 2. 경로 변경 시마다 페이지뷰 전송
  useEffect(() => {
    if (GA_ID) {
      // 신규 GA4는 send('pageview')를 권장하지만,
      // 명시적으로 pathname을 함께 보내는 것이 가장 정확합니다.
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search
      });
    }
  }, [location, GA_ID]);

  return null; // Hook이 아닌 컴포넌트로 사용할 경우 null 반환
};

export default RouterTrackerForAnalytics;